import { LightDomStyles, OutlineElement } from '@phase2/outline-core';

import { html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';

import componentStyles from './outline-global-main-navigation.css.lit';

/**
 * The Global Menu component
 */
@customElement('outline-global-main-navigation')
export class OutlineGlobalMainNavigation extends OutlineElement {
  static styles = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    [componentStyles],
    this.tagName.toLowerCase()
  );

  render(): TemplateResult {
    return html`
      <div class="global-main-navigation">
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-global-main-navigation': OutlineGlobalMainNavigation;
  }
}
